import { useRef, useState, useEffect } from 'react';
import {
	Link
} from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { FetchService, getSSOServerUrl } from '../../Base/BaseControl';
import IRILogo from "../../assets/img/IRILogo.png"

export default function Index({ Click, page }) {

	const navigate = useNavigate();
	const [getMain, setMain] = useState(0);

	useEffect(() => {
		toast.dismiss();
		document.title = "سامانه ها"
	}, []);

	const Owners = () => {
		toast.dismiss();
		document.title = "سامانه مالکان"
		setMain(1);
	}
	const ValidateLetter = () => {
		toast.dismiss();
		document.title = "صحت سنجی"
		navigate("/ValidateLetter");
	}

	const Employee = () => {
		toast.dismiss();
		document.title = "سامانه کاربران"
		navigate("/loginEmployee");
	}

	const Engineer = () => {
		toast.dismiss();
		document.title = "سامانه مهندس ناظر"
		navigate("/loginEngineer");
	}

	const login = () => {
		toast.dismiss();
		document.title = "سامانه مالکان"
		navigate("/login");
	}

	const loginTrade = () => {
		toast.dismiss();
		document.title = "سامانه مشاهده عوارض کسب و پیشه"
		navigate("/loginTrade");
	}

	const loginModernization = () => {
		toast.dismiss();
		document.title = "سامانه مشاهده عوارض نوسازی"
		navigate("/loginModernization");
	}
	const loginRefuseToll = () => {
		isActiveRefuse()
		toast.dismiss();
		document.title = "سامانه مشاهده عوارض پسماند"


	}

	const isActiveRefuse = () => {

		const input = {}
		FetchService("General/IsActiveRefuse", input, isActiveRefuseSuccess, isActiveRefuseFail)
	}

	const isActiveRefuseSuccess = (serviceResult) => {
		navigate("/LoginRefuse");

	}
	const isActiveRefuseFail = (error) => {
		toast.error(error)
	}

	const loginBySSO = async () => {
		const serverUrl = await getSSOServerUrl();

		const returnUrl = `${window.location.protocol}//${window.location.host}/LoginBySSO`;


		window.location.href = `${serverUrl}SSOLogin.aspx?projecturl=${returnUrl}`;
	};


	const BcckPage = () => {
		toast.dismiss();
		setMain(0);
	}

	return (
		<div id="bglogin">
			<div className="main container" style={{ flexDirection: 'flex-start' }}>
				<div className="row" style={{ width: '90%' }}>
					{getMain == 0 &&
						<>
							<div onClick={() => ValidateLetter()} className="text-primary cursor-pointer col-sm-12 col-lg-2 bg-white p-4 m-4 text-center rounded-2"
								style={{ boxShadow: "1px 9px 23px #000", background: "linear-gradient(359deg, rgb(158 152 255) 0%, rgb(191 191 201) 35%, rgb(255 255 255) 100%)" }}>
								<i class="fa fa-check-circle" aria-hidden="true" style={{ fontSize: '60px', color: '#000' }} />
								<br /><br />
								<div style={{ color: '#000' }}>{"صحت سنجی"}</div>
								<div style={{ color: '#000' }}>{"پروانه ، گواهی ، استعلامات"}</div>
							</div>
							<div onClick={() => Owners()} className="text-primary cursor-pointer col-sm-12 col-lg-2 bg-white p-4 m-4 text-center rounded-2"
								style={{ boxShadow: "1px 9px 23px #000", background: "linear-gradient(359deg, rgb(158 152 255) 0%, rgb(191 191 201) 35%, rgb(255 255 255) 100%)" }}>
								<i class="fa fa-user" aria-hidden="true" style={{ fontSize: '60px', color: '#000' }} /> <br /><br />
								<div style={{ color: '#000' }}>سامانه مالکان</div>
							</div>
							<div onClick={() => Employee()} className="cursor-pointer col-sm-12 col-lg-2 bg-white p-4 m-4 text-center rounded-2"
								style={{ boxShadow: "1px 9px 23px #000", background: "linear-gradient(359deg, rgb(158 152 255) 0%, rgb(191 191 201) 35%, rgb(255 255 255) 100%)" }}>
								<i class="fa fa-users" aria-hidden="true" style={{ fontSize: '60px' }} /> <br /><br />
								<div style={{ color: '#000' }}>سامانه کاربران</div>
							</div>
							<div onClick={() => Engineer()} className="cursor-pointer col-sm-12 col-lg-2 bg-white p-4 m-4 text-center rounded-2"
								style={{ boxShadow: "1px 9px 23px #000", background: "linear-gradient(359deg, rgb(158 152 255) 0%, rgb(191 191 201) 35%, rgb(255 255 255) 100%)" }}>
								<i class="fa fa-superpowers" aria-hidden="true" style={{ fontSize: '60px' }} /> <br /><br />
								<div style={{ color: '#000' }}>سامانه مهندس ناظر</div>
							</div>
						</>
					}
					{getMain == 1 &&
						<>
							<div onClick={() => login()} className="col-sm-12 cursor-pointer col-lg-5 bg-white p-4 m-4 text-center rounded-2"
								style={{ boxShadow: "1px 9px 23px #000", background: "linear-gradient(359deg, rgb(158 152 255) 0%, rgb(191 191 201) 35%, rgb(255 255 255) 100%)" }}>
								<i class="fa fa-home" aria-hidden="true" style={{ fontSize: '60px' }} /> <br /><br />
								سامانه شهرسازی
							</div>
							<div onClick={() => loginTrade()} className="col-sm-12 cursor-pointer col-lg-5 bg-white p-4 m-4 text-center rounded-2"
								style={{ boxShadow: "1px 9px 23px #000", background: "linear-gradient(359deg, rgb(158 152 255) 0%, rgb(191 191 201) 35%, rgb(255 255 255) 100%)" }}>
								<i class="fa fa-file" aria-hidden="true" style={{ fontSize: '60px' }} /> <br /><br />
								مشاهده عوارض کسب و پیشه
							</div>

							<div onClick={() => loginModernization()} className="col-sm-12 cursor-pointer col-lg-5 bg-white p-4 m-4 text-center rounded-2"
								style={{ boxShadow: "1px 9px 23px #000", background: "linear-gradient(359deg, rgb(158 152 255) 0%, rgb(191 191 201) 35%, rgb(255 255 255) 100%)" }}>
								<i class="fa fa-file-text" aria-hidden="true" style={{ fontSize: '60px' }} /> <br /><br />
								مشاهده عوارض نوسازی
							</div>
							<div onClick={() => loginRefuseToll()} className="col-sm-12 cursor-pointer col-lg-5 bg-white p-4 m-4 text-center rounded-2"
								style={{ boxShadow: "1px 9px 23px #000", background: "linear-gradient(359deg, rgb(158 152 255) 0%, rgb(191 191 201) 35%, rgb(255 255 255) 100%)" }}>
								<i class="fa fa-file-text-o " aria-hidden="true" style={{ fontSize: '60px' }} /> <br /><br />
								مشاهده عوارض پسماند
							</div>
							<div onClick={() => loginBySSO()} className="col-sm-12 cursor-pointer col-lg-5 bg-white p-4 m-4 text-center rounded-2"
								style={{ boxShadow: "1px 9px 23px #000", background: "linear-gradient(359deg, rgb(158 152 255) 0%, rgb(191 191 201) 35%, rgb(255 255 255) 100%)" }}>

								<img src={IRILogo} alt='IRILogo' style={{ height: '60px' }} />
								<br /><br />
								{"ورود با پنجره واحد خدمات وزارت کشور"}
							</div>
							<div onClick={() => BcckPage()} className="col-sm-12 cursor-pointer col-lg-5 bg-white p-4 m-4 text-center text-danger rounded-2"
								style={{ boxShadow: "1px 9px 23px #000", background: "linear-gradient(359deg, rgb(158 152 255) 0%, rgb(191 191 201) 35%, rgb(255 255 255) 100%)" }}>
								<i class="fa fa-arrow-left" aria-hidden="true" style={{ fontSize: '60px' }} /> <br /><br />
								<span className="text-black">بازگشت</span>
							</div>
						</>
					}
				</div>
			</div>
		</div>
	);
}